import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SelectOptionT } from './../../models/models';

export interface AdvertisersStateI {
    advertisersSO: SelectOptionT[];
    selectedAdvertiser: SelectOptionT | null;
};

const initialState: AdvertisersStateI = {
    advertisersSO: [],
    selectedAdvertiser: null,
};

const advertisersSlice = createSlice({
    name: 'advertisers',
    initialState,
    reducers: {
        setAdvertisers: (state, action: PayloadAction<SelectOptionT[]>) => {
            state.advertisersSO = action.payload;
        },
        setSelectedAdvertiser: (state, action: PayloadAction<SelectOptionT>) => {
            state.selectedAdvertiser = action.payload;
        },
    },
});

export const {
    setAdvertisers,
    setSelectedAdvertiser,
} = advertisersSlice.actions;

export default advertisersSlice.reducer;